import React from "react";
import { throttle } from "lodash";

const useInfiniteScroll = (ref) => {
  const [isAtBottom, setIsAtBottom] = React.useState(false);

  React.useEffect(() => {
    let currentEl = ref.current;
    const handleScroll = throttle(() => {
      if (
        Math.round(currentEl.scrollTop + currentEl.offsetHeight) >=
        currentEl.scrollHeight - 100
      ) {
        setIsAtBottom(true);
      } else {
        setIsAtBottom(false);
      }
    }, 100);

    if (currentEl) {
      currentEl.addEventListener("scroll", handleScroll);
      return () => {
        currentEl.removeEventListener("scroll", handleScroll);
      };
    }
  }, [ref]);

  return { isAtBottom };
}

export default useInfiniteScroll;